// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 4H21V18H14.4141L18.4141 22L17 23.4141L12 18.4141L7 23.4141L5.58594 22L9.58594 18H3V4H2V2H22V4ZM7 8.66699V14H9V8.66699H7ZM11 6V14H13V6H11ZM15 10V14H17V10H15Z"}}]};

const PlayChartFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'play-chart-filled',
    ref,
    icon: element,
  },
));

PlayChartFilledIcon.displayName = 'PlayChartFilledIcon';

export default PlayChartFilledIcon;
